import { AbgSxProps } from '@abg/typings';

export const titleStyling: AbgSxProps = {
  marginBottom: { sm: '12px', xs: '4px' },
};
